/**
 * Generated by orval v6.29.1 🍺
 * Do not edit manually.
 * Infomedia API
 * OpenAPI spec version: 1.0.0
 */
import { useCallback } from 'react';
import { useInfiniteQuery, useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import type {
  ForumCategory,
  ForumPost,
  ForumTopic,
  ForumTopicDetail,
  ForumTopicsList400,
  ForumTopicsList404,
  ForumTopicsListParams,
  ForumTopicsPostsList400,
  ForumTopicsPostsList404,
  ForumTopicsRetrieve404,
} from '../opoint.schemas';
import { useCustomAxiosInstance } from '.././custom-client';
import type { ErrorType } from '.././custom-client';

export const useForumCategoriesListHook = () => {
  const forumCategoriesList = useCustomAxiosInstance<ForumCategory[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return forumCategoriesList({
        url: `/forum/categories/`,
        method: 'GET',
        signal,
      });
    },
    [forumCategoriesList]
  );
};

export const getForumCategoriesListQueryKey = () => {
  return [`/forum/categories/`] as const;
};

export const useForumCategoriesListInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForumCategoriesListQueryKey();

  const forumCategoriesList = useForumCategoriesListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>
  > = ({ signal }) => forumCategoriesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumCategoriesListInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>
>;
export type ForumCategoriesListInfiniteQueryError = ErrorType<unknown>;

export const useForumCategoriesListInfinite = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
    TError,
    TData
  >;
}): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumCategoriesListInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useForumCategoriesListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForumCategoriesListQueryKey();

  const forumCategoriesList = useForumCategoriesListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>
  > = ({ signal }) => forumCategoriesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumCategoriesListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>
>;
export type ForumCategoriesListQueryError = ErrorType<unknown>;

export const useForumCategoriesList = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesListHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumCategoriesListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useForumCategoriesRetrieveHook = () => {
  const forumCategoriesRetrieve = useCustomAxiosInstance<ForumCategory>();

  return useCallback(
    (id: number, signal?: AbortSignal) => {
      return forumCategoriesRetrieve({
        url: `/forum/categories/${id}/`,
        method: 'GET',
        signal,
      });
    },
    [forumCategoriesRetrieve]
  );
};

export const getForumCategoriesRetrieveQueryKey = (id: number) => {
  return [`/forum/categories/${id}/`] as const;
};

export const useForumCategoriesRetrieveInfiniteQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getForumCategoriesRetrieveQueryKey(id);

  const forumCategoriesRetrieve = useForumCategoriesRetrieveHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>
  > = ({ signal }) => forumCategoriesRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumCategoriesRetrieveInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>
>;
export type ForumCategoriesRetrieveInfiniteQueryError = ErrorType<unknown>;

export const useForumCategoriesRetrieveInfinite = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumCategoriesRetrieveInfiniteQueryOptions(
    id,
    options
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useForumCategoriesRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getForumCategoriesRetrieveQueryKey(id);

  const forumCategoriesRetrieve = useForumCategoriesRetrieveHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>
  > = ({ signal }) => forumCategoriesRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumCategoriesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>
>;
export type ForumCategoriesRetrieveQueryError = ErrorType<unknown>;

export const useForumCategoriesRetrieve = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumCategoriesRetrieveHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumCategoriesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Retrieve forum topics filtered by tags
 */
export const useForumTopicsListHook = () => {
  const forumTopicsList = useCustomAxiosInstance<ForumTopic[]>();

  return useCallback(
    (params: ForumTopicsListParams, signal?: AbortSignal) => {
      return forumTopicsList({
        url: `/forum/topics/`,
        method: 'GET',
        params,
        signal,
      });
    },
    [forumTopicsList]
  );
};

export const getForumTopicsListQueryKey = (params: ForumTopicsListParams) => {
  return [`/forum/topics/`, ...(params ? [params] : [])] as const;
};

export const useForumTopicsListInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
  TError = ErrorType<ForumTopicsList400 | ForumTopicsList404>,
>(
  params: ForumTopicsListParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForumTopicsListQueryKey(params);

  const forumTopicsList = useForumTopicsListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>
  > = ({ signal }) => forumTopicsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumTopicsListInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>
>;
export type ForumTopicsListInfiniteQueryError = ErrorType<
  ForumTopicsList400 | ForumTopicsList404
>;

export const useForumTopicsListInfinite = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
  TError = ErrorType<ForumTopicsList400 | ForumTopicsList404>,
>(
  params: ForumTopicsListParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumTopicsListInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useForumTopicsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
  TError = ErrorType<ForumTopicsList400 | ForumTopicsList404>,
>(
  params: ForumTopicsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForumTopicsListQueryKey(params);

  const forumTopicsList = useForumTopicsListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>
  > = ({ signal }) => forumTopicsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumTopicsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>
>;
export type ForumTopicsListQueryError = ErrorType<
  ForumTopicsList400 | ForumTopicsList404
>;

export const useForumTopicsList = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
  TError = ErrorType<ForumTopicsList400 | ForumTopicsList404>,
>(
  params: ForumTopicsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsListHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumTopicsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Retrieve a specific forum topic by ID
 */
export const useForumTopicsRetrieveHook = () => {
  const forumTopicsRetrieve = useCustomAxiosInstance<ForumTopicDetail>();

  return useCallback(
    (id: number, signal?: AbortSignal) => {
      return forumTopicsRetrieve({
        url: `/forum/topics/${id}/`,
        method: 'GET',
        signal,
      });
    },
    [forumTopicsRetrieve]
  );
};

export const getForumTopicsRetrieveQueryKey = (id: number) => {
  return [`/forum/topics/${id}/`] as const;
};

export const useForumTopicsRetrieveInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
  TError = ErrorType<ForumTopicsRetrieve404>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForumTopicsRetrieveQueryKey(id);

  const forumTopicsRetrieve = useForumTopicsRetrieveHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>
  > = ({ signal }) => forumTopicsRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumTopicsRetrieveInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>
>;
export type ForumTopicsRetrieveInfiniteQueryError =
  ErrorType<ForumTopicsRetrieve404>;

export const useForumTopicsRetrieveInfinite = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
  TError = ErrorType<ForumTopicsRetrieve404>,
>(
  id: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumTopicsRetrieveInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useForumTopicsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
  TError = ErrorType<ForumTopicsRetrieve404>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getForumTopicsRetrieveQueryKey(id);

  const forumTopicsRetrieve = useForumTopicsRetrieveHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>
  > = ({ signal }) => forumTopicsRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumTopicsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>
>;
export type ForumTopicsRetrieveQueryError = ErrorType<ForumTopicsRetrieve404>;

export const useForumTopicsRetrieve = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
  TError = ErrorType<ForumTopicsRetrieve404>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsRetrieveHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumTopicsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Retrieve forum posts filtered by topic ID
 */
export const useForumTopicsPostsListHook = () => {
  const forumTopicsPostsList = useCustomAxiosInstance<ForumPost[]>();

  return useCallback(
    (topicId: number, signal?: AbortSignal) => {
      return forumTopicsPostsList({
        url: `/forum/topics/${topicId}/posts`,
        method: 'GET',
        signal,
      });
    },
    [forumTopicsPostsList]
  );
};

export const getForumTopicsPostsListQueryKey = (topicId: number) => {
  return [`/forum/topics/${topicId}/posts`] as const;
};

export const useForumTopicsPostsListInfiniteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
  TError = ErrorType<ForumTopicsPostsList400 | ForumTopicsPostsList404>,
>(
  topicId: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getForumTopicsPostsListQueryKey(topicId);

  const forumTopicsPostsList = useForumTopicsPostsListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>
  > = ({ signal }) => forumTopicsPostsList(topicId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!topicId,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumTopicsPostsListInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>
>;
export type ForumTopicsPostsListInfiniteQueryError = ErrorType<
  ForumTopicsPostsList400 | ForumTopicsPostsList404
>;

export const useForumTopicsPostsListInfinite = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
  TError = ErrorType<ForumTopicsPostsList400 | ForumTopicsPostsList404>,
>(
  topicId: number,
  options?: {
    query?: UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumTopicsPostsListInfiniteQueryOptions(
    topicId,
    options
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useForumTopicsPostsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
  TError = ErrorType<ForumTopicsPostsList400 | ForumTopicsPostsList404>,
>(
  topicId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getForumTopicsPostsListQueryKey(topicId);

  const forumTopicsPostsList = useForumTopicsPostsListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>
  > = ({ signal }) => forumTopicsPostsList(topicId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!topicId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ForumTopicsPostsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>
>;
export type ForumTopicsPostsListQueryError = ErrorType<
  ForumTopicsPostsList400 | ForumTopicsPostsList404
>;

export const useForumTopicsPostsList = <
  TData = Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
  TError = ErrorType<ForumTopicsPostsList400 | ForumTopicsPostsList404>,
>(
  topicId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useForumTopicsPostsListHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useForumTopicsPostsListQueryOptions(topicId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
